/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Michael Kokoulin
 * @version 1.0.1
 * @since 1.0.0
 */
import produce from 'immer';

import { ValueOf } from '../../types/globalTypes';
import {
    initTranslation,
    LOAD_EXTERNAL_TRANSLATIONS_FAILURE,
    LOAD_EXTERNAL_TRANSLATIONS_FINISH,
    LOAD_EXTERNAL_TRANSLATIONS_START,
    LOAD_EXTERNAL_TRANSLATIONS_SUCCESS,
    LOAD_INTERNAL_TRANSLATIONS_FAIL,
    LOAD_INTERNAL_TRANSLATIONS_START,
    LOAD_INTERNAL_TRANSLATIONS_SUCCESS,
    SET_LOCALE,
} from './constants';
import { IIntActionTypes } from './intActions';
import { ILocaleEnum, LocaleEnum } from './intConstants';
import { ITranslation } from './types';

export interface IIntState {
    custom: { [key: string]: string };
    errorMessage: string;
    isError: boolean;
    isFinished: boolean;
    isLoading: boolean;
    locale: ValueOf<ILocaleEnum>;
    translation: ITranslation;
}

export const initialIntState: IIntState = {
    custom: {},
    errorMessage: '',
    isError: false,
    isFinished: false,
    isLoading: false,
    locale: LocaleEnum.ru,
    translation: initTranslation,
};
/**
 * Reducer for control i18n
 */
const intReducer = (state: IIntState = initialIntState, action: IIntActionTypes) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SET_LOCALE:
                draft.locale = action.payload;
                break;
            case LOAD_INTERNAL_TRANSLATIONS_START:
                draft.isLoading = true;
                draft.isError = false;
                break;
            case LOAD_INTERNAL_TRANSLATIONS_SUCCESS:
                draft.isLoading = true;
                draft.isError = false;
                draft.translation = { ...draft.translation, ...action.payload };
                break;
            case LOAD_INTERNAL_TRANSLATIONS_FAIL:
                draft.errorMessage = action.payload;
                draft.isError = true;
                draft.isLoading = false;
                break;
            case LOAD_EXTERNAL_TRANSLATIONS_START:
                break;
            case LOAD_EXTERNAL_TRANSLATIONS_SUCCESS:
                draft.custom = action.payload;
                break;
            case LOAD_EXTERNAL_TRANSLATIONS_FAILURE:
                draft.errorMessage = action.payload;
                draft.isError = true;
                break;
            case LOAD_EXTERNAL_TRANSLATIONS_FINISH:
                draft.isFinished = true;
                break;
            default:
                break;
        }
    });

export default intReducer;
